// extracted by mini-css-extract-plugin
export default {"label":"countingBody_label__C5xuY","errorInput":"countingBody_errorInput__Wr9y5"};